export default __webpack_public_path__ + "static/media/T660MANF5.62b9a0fb.pdf";